export default __webpack_public_path__ + "static/media/jobhunt.8a9281a0.jpg";